module.exports = __webpack_public_path__ + "webauthn_authenticator.fbfa4fadf2d1802081294b584f17159f.png";